import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadInstitutionItemTemplate: IInstitutionItemTemplateLoadActionCreator = (institutionId) => {
        return {
            type: ACTION_INSTITUTIONITEMTEMPLATE_LOAD,
            institutionId
        }
    },
    LoadInstitutionItemTemplateById: IInstitutionItemTemplateLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_INSTITUTIONITEMTEMPLATE_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IInstitutionItemTemplateLoadSuccessActionCreator = (formData, formDataInstitutioned, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONITEMTEMPLATE_LOAD_SUCCESS,
            formData,
            formDataInstitutioned,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IInstitutionItemTemplateLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONITEMTEMPLATE_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveInstitutionItemTemplate: IInstitutionItemTemplateSaveActionCreator = (formData, collectionFormData) => {
        return {
            type: ACTION_INSTITUTIONITEMTEMPLATE_SAVE,
            formData,
            collectionFormData
        }
    },
    SaveSuccess: IInstitutionItemTemplateSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONITEMTEMPLATE_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IInstitutionItemTemplateSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONITEMTEMPLATE_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateInstitutionItemTemplate: IInstitutionItemTemplateCreateActionCreator = (institutionId) => {

        return {
            type: ACTION_INSTITUTIONITEMTEMPLATE_CREATE,
            institutionId
        }
    },
    CreateSuccess: IInstitutionItemTemplateCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_INSTITUTIONITEMTEMPLATE_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IInstitutionItemTemplateCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONITEMTEMPLATE_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateInstitutionItemTemplate: IInstitutionItemTemplateValidateActionCreator = (formData, collectionFormData) => {
        return {
            type: ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE,
            formData,
            collectionFormData
        }
    },
    ValidateSuccess: IInstitutionItemTemplateValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IInstitutionItemTemplateValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IInstitutionItemTemplateClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_INSTITUTIONITEMTEMPLATE_CLEAR,
            propertiesToClear
        }
    },
    Filter: IInstitutionItemTemplateFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_INSTITUTIONITEMTEMPLATES_FILTER,
            formFilter
        }
    };



export const
    ACTION_INSTITUTIONITEMTEMPLATE_LOAD = "ACTION_INSTITUTIONITEMTEMPLATE_LOAD",
    ACTION_INSTITUTIONITEMTEMPLATE_LOAD_BY_ID = "ACTION_INSTITUTIONITEMTEMPLATE_LOAD_BY_ID",
    ACTION_INSTITUTIONITEMTEMPLATE_LOAD_SUCCESS = "ACTION_INSTITUTIONITEMTEMPLATE_LOAD_SUCCESS",
    ACTION_INSTITUTIONITEMTEMPLATE_LOAD_FAILURE = "ACTION_INSTITUTIONITEMTEMPLATE_LOAD_FAILURE",

    ACTION_INSTITUTIONITEMTEMPLATE_SAVE = "ACTION_INSTITUTIONITEMTEMPLATE_SAVE",
    ACTION_INSTITUTIONITEMTEMPLATE_SAVE_SUCCESS = "ACTION_INSTITUTIONITEMTEMPLATE_SAVE_SUCCESS",
    ACTION_INSTITUTIONITEMTEMPLATE_SAVE_FAILURE = "ACTION_INSTITUTIONITEMTEMPLATE_SAVE_FAILURE",

    ACTION_INSTITUTIONITEMTEMPLATE_CREATE = "ACTION_INSTITUTIONITEMTEMPLATE_CREATE",
    ACTION_INSTITUTIONITEMTEMPLATE_CREATE_SUCCESS = "ACTION_INSTITUTIONITEMTEMPLATE_CREATE_SUCCESS",
    ACTION_INSTITUTIONITEMTEMPLATE_CREATE_FAILURE = "ACTION_INSTITUTIONITEMTEMPLATE_CREATE_FAILURE",

    ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE = "ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE",
    ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE_SUCCESS = "ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE_SUCCESS",
    ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE_FAILURE = "ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE_FAILURE",

    ACTION_INSTITUTIONITEMTEMPLATE_CLEAR = "ACTION_INSTITUTIONITEMTEMPLATE_CLEAR",
    ACTION_INSTITUTIONITEMTEMPLATES_FILTER = "ACTION_INSTITUTIONITEMTEMPLATES_FILTER";

export interface IInstitutionItemTemplateLoadAction {
    type: "ACTION_INSTITUTIONITEMTEMPLATE_LOAD";
    institutionId: number;
}

export interface IInstitutionItemTemplateLoadActionCreator {
    (institutionId: number): IInstitutionItemTemplateLoadAction;
}

export interface IInstitutionItemTemplateLoadSuccessAction {
    type: "ACTION_INSTITUTIONITEMTEMPLATE_LOAD_SUCCESS";
    formData: Dtos.InstitutionItemTemplate | Dtos.InstitutionItemTemplate[];
    formDataInstitutioned: Dtos.InstitutionItemTemplateCategory[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionItemTemplateLoadSuccessActionCreator {
    (
        formData: Dtos.InstitutionItemTemplate | Dtos.InstitutionItemTemplate[],
        formDataInstitutioned: Dtos.InstitutionItemTemplateCategory[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionItemTemplateLoadSuccessAction;
}

export interface IInstitutionItemTemplateLoadFailureAction {
    type: "ACTION_INSTITUTIONITEMTEMPLATE_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionItemTemplateLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionItemTemplateLoadFailureAction;
}

export interface IInstitutionItemTemplateLoadByIdAction {
    type: "ACTION_INSTITUTIONITEMTEMPLATE_LOAD_BY_ID";
    id: number;
}

export interface IInstitutionItemTemplateLoadByIdActionCreator {
    (id: number): IInstitutionItemTemplateLoadByIdAction;
}

export interface IInstitutionItemTemplateSaveAction {
    type: "ACTION_INSTITUTIONITEMTEMPLATE_SAVE";
    formData: Dtos.InstitutionItemTemplate;
    collectionFormData: Dtos.Collection;

}

export interface IInstitutionItemTemplateSaveActionCreator {
    (
        formData: Dtos.InstitutionItemTemplate,
        collectionFormData: Dtos.Collection
    ): IInstitutionItemTemplateSaveAction;
}

export interface IInstitutionItemTemplateSaveSuccessAction {
    type: "ACTION_INSTITUTIONITEMTEMPLATE_SAVE_SUCCESS";
    formData: Dtos.InstitutionItemTemplate;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionItemTemplateSaveSuccessActionCreator {
    (
        formData: Dtos.InstitutionItemTemplate,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionItemTemplateSaveSuccessAction;
}

export interface IInstitutionItemTemplateSaveFailureAction {
    type: "ACTION_INSTITUTIONITEMTEMPLATE_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionItemTemplateSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionItemTemplateSaveFailureAction;
}

export interface IInstitutionItemTemplateCreateAction {
    type: "ACTION_INSTITUTIONITEMTEMPLATE_CREATE";
    institutionId?: number;
}

export interface IInstitutionItemTemplateCreateActionCreator {
    (institutionId?: number): IInstitutionItemTemplateCreateAction
}

export interface IInstitutionItemTemplateCreateSuccessAction {
    type: "ACTION_INSTITUTIONITEMTEMPLATE_CREATE_SUCCESS";
    formData: Dtos.InstitutionItemTemplate;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface IInstitutionItemTemplateCreateSuccessActionCreator {
    (
        formData: Dtos.InstitutionItemTemplate,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IInstitutionItemTemplateCreateSuccessAction;
}

export interface IInstitutionItemTemplateCreateFailureAction {
    type: "ACTION_INSTITUTIONITEMTEMPLATE_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionItemTemplateCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionItemTemplateCreateFailureAction;
}

export interface IInstitutionItemTemplateValidateAction {
    type: "ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE";
    formData: Dtos.InstitutionItemTemplate;
    collectionFormData: Dtos.Collection;

}

export interface IInstitutionItemTemplateValidateActionCreator {
    (
        formData: Dtos.InstitutionItemTemplate,
        collectionFormData: Dtos.Collection
    ): IInstitutionItemTemplateValidateAction;
}

export interface IInstitutionItemTemplateValidateSuccessAction {
    type: "ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE_SUCCESS";
    formData: Dtos.InstitutionItemTemplate;
    formState: Dtos.FormState;
    responseStatus: Dtos.ResponseStatus;
}

export interface IInstitutionItemTemplateValidateSuccessActionCreator {
    (
        formData: Dtos.InstitutionItemTemplate,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IInstitutionItemTemplateValidateSuccessAction;
}

export interface IInstitutionItemTemplateValidateFailureAction {
    type: "ACTION_INSTITUTIONITEMTEMPLATE_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IInstitutionItemTemplateValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IInstitutionItemTemplateValidateFailureAction;
}

export interface IInstitutionItemTemplateClearAction {
    type: "ACTION_INSTITUTIONITEMTEMPLATE_CLEAR";
    propertiesToClear?: string[];
}

export interface IInstitutionItemTemplateClearActionCreator {
    (propertiesToClear?: string[]): IInstitutionItemTemplateClearAction;
}

export interface IInstitutionItemTemplateFilterActionCreator {
    (formFilter: IFormFilter): IInstitutionItemTemplateFilterAction;
}

export interface IInstitutionItemTemplateFilterAction {
    type: "ACTION_INSTITUTIONITEMTEMPLATES_FILTER";
    formFilter: IFormFilter;
}

export type InstitutionItemTemplateAction =
    IInstitutionItemTemplateLoadAction |
    IInstitutionItemTemplateLoadByIdAction |
    IInstitutionItemTemplateLoadFailureAction |
    IInstitutionItemTemplateLoadSuccessAction |
    IInstitutionItemTemplateSaveAction |
    IInstitutionItemTemplateSaveSuccessAction |
    IInstitutionItemTemplateSaveFailureAction |
    IInstitutionItemTemplateCreateAction |
    IInstitutionItemTemplateCreateSuccessAction |
    IInstitutionItemTemplateCreateFailureAction |
    IInstitutionItemTemplateValidateAction |
    IInstitutionItemTemplateValidateSuccessAction |
    IInstitutionItemTemplateValidateFailureAction |
    IInstitutionItemTemplateClearAction |
    IInstitutionItemTemplateFilterAction;
